import { ReactComponent as Orders } from "assets/icons/OrdersSideBarIcon.svg";
import { ReactComponent as Delivery } from "assets/icons/stopwatch.svg";
import { ReactComponent as Stocks } from "assets/icons/clipboard.svg";
import { ReactComponent as Reporting } from "assets/icons/ReportSidebarIcon.svg";
import { ReactComponent as Invoice } from "assets/icons/chart.svg";
import { ReactComponent as Operation } from "assets/icons/folder-open.svg";
import { ReactComponent as Users } from "assets/icons/person-add.svg";
import { ReactComponent as Setting } from "assets/icons/Setting.svg";
import { ReactComponent as hubs } from "assets/icons/restaurant.svg";
import { ReactComponent as PickOpack } from "assets/icons/filter.svg";

const Icons = [
    { title: "سفارشات", Icon: Orders },
    { title: "تحویل سفارشات", Icon: Delivery },
    { title: "مدیریت استاک", Icon: Stocks },
    { title: "گزارشات", Icon: Reporting },
    { title: "کاربر", Icon: Users },
    { title: "عملیات ثبت", Icon: Operation },
    { title: "عملیات هاب", Icon: hubs },
    { title: "فاکتور رسمی", Icon: Invoice },
    { title: "تنظیمات", Icon: Setting },
    { title: "پیک و پک", Icon: PickOpack },
    { title: "داشبورد", Icon: PickOpack },
];

export default Icons;
